/* ========================================
   KL CART SYNC AFTER SIGN-IN
   A guest builds a cart, then signs in. Member prices in the cart come from
   the price program (kl-price-engine, a cart-lines discount) and Shopify only
   re-runs it when the cart CHANGES. Signing in changes the buyer, not the
   cart, so the first page(s) after sign-in show the guest arithmetic: $35
   with no member saving. Checkout re-runs it, which is why checkout is right.

   Fix: when the server says a signed-in member has a tee line with no saving
   (the hidden #kl-cart-sync marker from snippets/kl-cart-sync.liquid, rendered
   in layout/theme.liquid on every page), send ONE empty cart update — a no-op
   nudge that makes Shopify re-run the price program — then fire the theme's
   own cart:refresh event so its CartDrawer (app.js) and Cart (cart.js) redraw
   the drawer, the cart icon count and the cart page through their existing
   section fetches. Nothing new renders anything.

   Guard: the script only remembers (sessionStorage) a cart STATE it has
   already nudged and found nothing to repair — key = customer id + cart token
   (the cart cookie) + the served total. Repairs write nothing: after a repair
   the marker is simply not served again. So a new cart (HOD r1 D1), or the
   same cart going stale again — sign-out re-prices it as a guest on the same
   token (HOD r2 D2) — is always repaired, while a line that genuinely has no
   saving costs one nudge per session and never loops. A failed nudge writes
   nothing and is retried on the next page. Guests: no marker, nothing runs.
   Added: 2026-09-16 (Brent's editor agent found the stale cart). r2–r4 same day.
   ======================================== */

(function () {
  function whenLoaded() {
    return new Promise(function (resolve) {
      if (document.readyState === 'complete') resolve();
      else window.addEventListener('load', resolve, { once: true });
    });
  }

  function cartUpdateUrl() {
    // The theme's own route list (layout/theme.liquid → theme.routes), as
    // assets/cart.js and app.js use it; the plain path only if it is missing.
    var r = window.theme && window.theme.routes && window.theme.routes.cart_update_url;
    return (r || '/cart/update') + '.js';
  }

  function cartToken() {
    // Shopify's cart cookie holds the cart token; not HttpOnly, so readable here.
    var m = document.cookie.match(/(?:^|; )cart=([^;]+)/);
    return m ? decodeURIComponent(m[1]).split('?')[0] : '';
  }

  function run() {
    var marker = document.getElementById('kl-cart-sync');
    var stale = marker && marker.getAttribute('data-kl-cart-stale');
    if (!stale) return;
    var servedTotal = marker.getAttribute('data-kl-cart-total') || '';

    var key = 'kl-cart-sync:' + stale + ':' + cartToken() + ':' + servedTotal;
    try { if (window.sessionStorage.getItem(key)) return; } catch (e) {}

    var nudge = fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: {} })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart nudge failed: ' + r.status);
      return r.json();
    });

    // The theme's cart components register their cart:refresh listeners by
    // window load (cart.js) — wait for both the nudge and load before firing.
    Promise.all([nudge, whenLoaded()])
      .then(function (results) {
        var cart = results[0] || {};
        marker.removeAttribute('data-kl-cart-stale');
        if (String(cart.total_price) === servedTotal) {
          // Nothing moved: this state has no saving to apply. Remember it so
          // it is not nudged again this session; nothing to redraw.
          try { window.sessionStorage.setItem(key, String(Date.now())); } catch (e) {}
          return;
        }
        // Repaired: redraw through the theme's own listeners. No key — the
        // marker will not be served for this cart again unless it goes stale.
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { /* nothing written: the page stays as served and the next page retries */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
